/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import React from 'react'

import { ability, AbilityContext } from '@builddocs/data-management'
import { initI18n } from '@builddocs/exdoc-app/data-access-translate'
import { MuiProviderCrutch } from '@builddocs/mui'
import { ViewerProvider } from '@builddocs/shared/feature-pdf-viewer'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import { CssBaseline } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import ruLocale from 'date-fns/locale/ru'
import { SnackbarProvider } from 'notistack'
import ReactDOM from 'react-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { RecoilRoot } from 'recoil'

import App from './app/App'
import { CookieNoticeProvider, PaywallProvider } from './providers'
import workersRegistration from './WebWorkers/workersRegistration'

import './app/assets/main.scss'

// WTF: если бы можно было добавить отдельную либу с этим сломанным nx'ом...
import '../../../libs/shared/data-management/src/lib/sideEffects.container'

initI18n()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RecoilRoot>
        <AbilityContext.Provider value={ability}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={ruLocale}>
            <MuiProviderCrutch>
              <CssBaseline />
              <SnackbarProvider>
                <ViewerProvider>
                  <CookieNoticeProvider>
                    <PaywallProvider>
                      <App />
                    </PaywallProvider>
                  </CookieNoticeProvider>
                </ViewerProvider>
              </SnackbarProvider>
            </MuiProviderCrutch>
          </LocalizationProvider>
        </AbilityContext.Provider>
      </RecoilRoot>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)

// sw.register({
//   onUpdate: registration => {
//     const registrationWaiting = registration.waiting

//     if (
//       registrationWaiting
//       //    &&  window.confirm('🚀 Доступно обновление. Обновить сейчас?')
//     ) {
//       registrationWaiting.postMessage({ type: 'SKIP_WAITING' })

//       registrationWaiting.addEventListener('statechange', (e: any) => {
//         if (e?.target?.state === 'activated') {
//           window.location.reload()
//         }
//       })
//     }
//   },
//   onSuccess: () => {
//     // caches.open('v1')
//     //   .then(cache => cache.addAll([
//     //     './images/bg1.jpg'
//     //   ]))
//   },
// })

if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/service-worker.js').then(
      function (registration) {
        // Registration was successful
        console.log(
          'ServiceWorker registration successful with scope: ',
          registration.scope,
        )
      },
      function (err) {
        // registration failed :(
        console.log('ServiceWorker registration failed: ', err)
      },
    )
  })
}

workersRegistration()
